<template>
  <v-snackbar :timeout="0" color="orange" v-model="value" top vertical>
    {{ text }}
  </v-snackbar>
</template>
<script>
export default {
  props: ["value", "text"],
  methods: {
    close() {
      this.$emit("input", !this.value);
    }
  }
};
</script>
<style></style>
